module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-app"
  }, [_c('div', {
    staticClass: "l-app__center"
  }, [_c('div', {
    staticClass: "c-message"
  }, [_c('div', {
    staticClass: "c-message__media"
  }, [_c('h1', {
    staticClass: "u-fs-128"
  }, [_vm._v("500")])]), _vm._v(" "), _c('p', {
    staticClass: "c-message__title"
  }, [_vm._v("OOPS!")]), _vm._v(" "), _c('p', {
    staticClass: "c-message__content"
  }, [_vm._v("\n        O servidor não responde, tente novamente mais tarde!\n      ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f962311c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/ServerError.vue
// module id = 3502
// module chunks = 0